import { API_KEY_DEFAULT_SCOPES, API_KEY_SCOPES, type ApiKeyDto, type ApiKeyScope, type IssueApiKeyRequestDto } from '@gr/core/accounts/identity/api-keys';
import { BlogRole, type MyBlogDto } from '@gr/core/accounts/workspaces/dto';

// Ключи API в интерфейсе (IAM-UC-9…11): правила без React.

/** Значения формы выпуска: области — флажками, владелец — только у администратора. */
export interface ApiKeyFormValues {
  userId: string | null;
  name: string;
  scopes: Record<ApiKeyScope, boolean>;
}

/** Отмечены области по умолчанию: чтение и контент — то, что нужно боту приёма материалов. */
export function apiKeyFormDefaults(): ApiKeyFormValues {
  return { userId: null, name: '', scopes: Object.fromEntries(API_KEY_SCOPES.map((scope) => [scope, API_KEY_DEFAULT_SCOPES.includes(scope)])) as Record<ApiKeyScope, boolean> };
}

export function toIssueRequest(values: ApiKeyFormValues): IssueApiKeyRequestDto {
  return { name: values.name, scopes: API_KEY_SCOPES.filter((scope) => values.scopes[scope]) };
}

/** IAM-UC-9.CC-1: свой ключ выпускает автор — владелец или редактор хотя бы одного блога. */
export function canIssueOwnApiKeys(blogs: readonly MyBlogDto[]): boolean {
  return blogs.some((blog) => blog.role === BlogRole.Owner || blog.role === BlogRole.Editor);
}

export function isApiKeyActive(key: ApiKeyDto): boolean {
  return key.revokedAt === null;
}
